document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value) return;

      var raw = input.value.trim();
      var digitsOnly = raw.replace(/-/g, '');
      var isIsbnLike = /^[0-9]{9,13}$/.test(digitsOnly);

      if (isIsbnLike) {
        // Exact match on the barcode/ISBN field — bypasses semantic search entirely
        input.value = 'variants.barcode:' + digitsOnly;
      } else if (raw.charAt(0) !== '"') {
        // Phrase search across title, author (SKU), vendor, etc.
        // Forces tight matching instead of the broad semantic blowout
        input.value = '"' + raw.replace(/"/g, '') + '"';
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);
  var rawQ = params.get('q');
  if (!rawQ) return;

  var cleanQ = rawQ;
  if (cleanQ.indexOf('variants.barcode:') === 0) {
    cleanQ = cleanQ.replace('variants.barcode:', '');
  }
  cleanQ = cleanQ.replace(/^"+|"+$/g, ''); // strip wrapping quotes

  if (cleanQ === rawQ) return; // nothing to clean up

  // Fix the value shown in any search input boxes
  document.querySelectorAll('input[name="q"]').forEach(function (input) {
    if (input.value === rawQ) input.value = cleanQ;
  });

  // Fix any visible "results for ..." text or headings
  var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
  var node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue.indexOf(rawQ) !== -1) {
      node.nodeValue = node.nodeValue.split(rawQ).join(cleanQ);
    }
  }

  // Fix the browser tab title too
  if (document.title.indexOf(rawQ) !== -1) {
    document.title = document.title.split(rawQ).join(cleanQ);
  }
});